import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  moduleReducer,
  initialModuleState
} from '@shared/context/reducers/ModuleReducer';
import {
  setIsBH,
  setIsBHReason,
  setModule,
  setSubModule
} from '@shared/context/actions/ModuleActions';
import {ModuleModel} from '@shared/context/mappers/ModuleTypesMapper';

interface ModuleContextInterface {
  readonly moduleState: ModuleModel;
  readonly setModuleData: (data: object) => void;
  readonly setSubModuleData: (data: object) => void;
  readonly setIsBHData: (data: any) => void;
  readonly setIsBHReasonData: (data: any) => void;
}

const ModuleContext = createContext<ModuleContextInterface>(
  {} as ModuleContextInterface
);

export const useModuleContext = (): ModuleContextInterface =>
  useContext(ModuleContext);

export const ModuleContextProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [moduleState, dispatch] = useReducer(moduleReducer, initialModuleState);

  const setModuleData = (data: any): void => {
    setModule(dispatch, data);
  };

  const setSubModuleData = (data: any): void => {
    setSubModule(dispatch, data);
  };

  const setIsBHData = (data: any): void => {
    setIsBH(dispatch, data);
  };

  const setIsBHReasonData = (data: any): void => {
    setIsBHReason(dispatch, data);
  };

  return (
    <ModuleContext.Provider
      value={{
        moduleState,
        setModuleData,
        setSubModuleData,
        setIsBHData,
        setIsBHReasonData
      }}>
      {children}
    </ModuleContext.Provider>
  );
};
